module.exports = __webpack_public_path__ + "assets/150d55b0ec8bba3ccf3ab60bb2e66138.mp4";